// Invoice type (state.table.invoiceType) -> the scope level that owns it.
export const INVOICE_TYPE_SCOPE = {
    0: 20, // Company
    1: 40, // Partner
    2: 60, // Wholesaler
};

/**
 * Whether a user can edit an invoice or change its status. Organisations may
 * only view their own invoices, so the user's scope must be above the level
 * that owns the invoice type.
 *
 * @param {number} scope        The user's scope (state.login.requiredScope).
 * @param {number} invoiceType  0 Company, 1 Partner, 2 Wholesaler.
 * @returns {boolean}
 */
export const canManageInvoice = (scope, invoiceType) => {
    const typeScope = INVOICE_TYPE_SCOPE[Number(invoiceType)];
    return typeScope !== undefined && Number(scope) > typeScope;
};
